import {RestService} from "@/services/rest/RestService";

export class TrainingsRestService extends RestService {

    public async findTrainingsData(): Promise<Object> {
        const axiosInstance = this.getAxiosInstance();
        axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

        const response = await axiosInstance.get(
            "https://cdn.dp2.digital-pharma.eu/trainings/trainings.json"
        );

        return response.data;
    }
}
